import * as React from "react";

import {cs}                  from "@Common/react/chain-services";
import {HoldRepeatingAction} from "@Common/react/hold-repeating-action";
import {Interval}            from "@Common/react/interval";
import {UseState}            from "@Common/react/use-state";
import "./color-line-scroller.scss";

export const ColorLineScroller = ({next}) => {

    let scrollingDom = null;

    return cs(
        ["more", (_, next) => UseState({
            initValue: {left: false, right: false},
            next,
        })],
        ["checkScroll", ({more}, next) => next(() => {
            const moreLeft  : boolean = scrollingDom.scrollLeft > 0;
            const moreRight : boolean = scrollingDom.scrollLeft < scrollingDom.scrollWidth - scrollingDom.clientWidth;

            if (more.value.left !== moreLeft || more.value.right !== moreRight) {
                more.onChange({left: moreLeft, right: moreRight});
            }
        })],
        ({checkScroll}, next) => Interval({
            delay: 1000,
            fn: checkScroll,
            next,
        }),
        ({more, checkScroll}) => (
            <div
                className="color-line-scroller-e7a"
            >
                <div
                    className="scrolling"
                    ref={(r) => {
                        if (r) {
                            scrollingDom = r;
                            checkScroll();
                        }
                    }}
                    onScroll={checkScroll}
                >
                    {next()}
                </div>


                {more.value.left && cs(
                    ["hold", (_, next) => <HoldRepeatingAction {...{
                        action: () => scrollingDom.scrollLeft -= 150,
                        next,
                    }} />],
                    ({hold}) => (
                        <div
                            className="pointer left"
                            onMouseDown={hold.start}
                            onMouseUp={hold.stop}
                        >
                            <i className="fa fa-chevron-left" xd-qa-type="icon" xd-qa-name="arrow_left"/>
                        </div>
                    ),
                )}

                {more.value.right && cs(
                    ["hold", (_, next) => <HoldRepeatingAction {...{
                        action: () => scrollingDom.scrollLeft += 150,
                        next,
                    }} />],
                    ({hold}) => (
                        <div
                            className="pointer right"
                            onMouseDown={hold.start}
                            onMouseUp={hold.stop}
                        >
                            <i className="fa fa-chevron-right" xd-qa-type="icon" xd-qa-name="arrow_right"/>
                        </div>
                    )
                )}
            </div>
        )
    );
};